/* Menue der Kopfzeile fuer schmale Schirme.
 *
 * Der Knopf erscheint nur unter 768 px (css/header.css). Ohne JavaScript
 * bleibt das Menue zu und die Seiten sind ueber den Footer erreichbar - dort
 * stehen dieselben Ziele.
 */
(function () {
  'use strict';

  /* --- Sorten-Panel ---------------------------------------------------
     Im Markup steht ein <details>: ohne JavaScript klappt die Liste auf und
     die sechs Links sind erreichbar. Hier wird daraus ein Panel mit
     aria-expanded, das auf Klick oder Taste aufgeht und mit Escape zugeht.

     `open` bleibt gesetzt, solange das Panel sichtbar ist - sonst wuerde der
     Browser die Flaeche sofort ausblenden und der Uebergang liefe ins Leere.
     Das Ein- und Ausblenden macht [data-zu]. */
  /* 20.10.2026 (Kevin): Am Computer gibt es zwei Flaechen, „Einkaufen“ und
     „Wissen & Kochen“. Jede bekommt dasselbe Verhalten; geht eine auf, geht
     die andere zu. */
  var allePanels = document.querySelectorAll('.sortenpanel');
  allePanels.forEach(function (panel) {
    var schalter = panel.querySelector('.sortenpanel__schalter');
    if (!schalter) return;

    panel.setAttribute('data-js', '');
    panel.setAttribute('data-zu', '');
    panel.open = false;
    schalter.setAttribute('role', 'button');
    schalter.setAttribute('tabindex', '0');
    schalter.setAttribute('aria-expanded', 'false');
    var zeit;

    /* 11.10.2026: Die Dosenbilder im Panel tragen data-src und kommen erst beim ersten Aufklappen. */
    function bilderLaden() {
      panel.querySelectorAll('img[data-src]').forEach(function (b) {
        b.loading = 'eager';
        if (b.dataset.sizes) b.sizes = b.dataset.sizes;
        if (b.dataset.srcset) b.srcset = b.dataset.srcset;
        b.src = b.dataset.src;
        b.removeAttribute('data-src');
      });
    }

    function pAuf() {
      allePanels.forEach(function (o) { if (o !== panel && o._schliessen) o._schliessen(); });
      bilderLaden();
      window.clearTimeout(zeit);
      panel.open = true;
      /* Ein Bild abwarten, sonst faengt der Uebergang beim Endzustand an. */
      requestAnimationFrame(function () { panel.removeAttribute('data-zu'); });
      schalter.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', pTaste);
      document.addEventListener('pointerdown', pDaneben, true);
    }

    function pZu(fokus) {
      panel.setAttribute('data-zu', '');
      schalter.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', pTaste);
      document.removeEventListener('pointerdown', pDaneben, true);
      window.clearTimeout(zeit);
      zeit = window.setTimeout(function () {
        if (schalter.getAttribute('aria-expanded') === 'false') panel.open = false;
      }, 200);
      if (fokus) schalter.focus();
    }

    function offen() { return schalter.getAttribute('aria-expanded') === 'true'; }
    function pTaste(e) { if (e.key === 'Escape') { geklickt = false; pZu(true); } }
    function pDaneben(e) {
      if (!panel.contains(e.target)) { geklickt = false; pZu(false); }
    }

    /* Hover UND Klick, ohne dass eines das andere aufhebt.
     *
     * Ohne `geklickt` passierte Folgendes: die Maus faehrt auf "Sorten", der
     * Hover oeffnet das Panel - und der Klick, der gleich darauf kommt, sieht
     * ein offenes Panel und macht es wieder zu. Das Panel ging auf Klick also
     * nie auf.
     *
     * Jetzt merkt sich `geklickt`, ob jemand das Panel festgeklickt hat. Ein
     * festgeklicktes Panel bleibt offen, wenn die Maus es verlaesst; erst der
     * naechste Klick (oder Escape, oder ein Klick daneben) schliesst es. */
    var geklickt = false;

    function umschalten(fokus) {
      if (geklickt) { geklickt = false; pZu(fokus); }
      else { geklickt = true; if (!offen()) pAuf(); }
    }

    /* <summary> schaltet `open` von sich aus um. Das uebernehmen wir hier, */
    /* sonst springt die Flaeche einmal auf und der Uebergang fehlt. */
    schalter.addEventListener('click', function (e) {
      e.preventDefault();
      /* detail 0 = Klick per Tastatur; nur dann den Fokus zurücksetzen, sonst zeigt Safari nach dem Mausklick den Fokusring. */
      umschalten(e.detail === 0);
    });
    schalter.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        umschalten(true);
      }
    });

    /* 28.10.2026 (Kevin, eingefügter Auftrag „Hauptnavigation und Megamenü“): Das Panel geht nur noch
       auf Klick oder Taste auf, nicht mehr beim Darüberfahren. Vorher öffnete es sich, sobald die Maus auf dem
       Weg zu „So geht's“ darüber strich. Klick daneben, zweiter Klick und Escape schließen es (oben). */
    /* Wandert der Fokus mit der Tastatur aus dem Panel heraus, geht es zu. */
    panel.addEventListener('focusout', function (e) {
      if (offen() && !panel.contains(e.relatedTarget)) pZu(false);
    });
    panel._schliessen = function () { geklickt = false; if (offen()) pZu(false); };
  });

  /* --- Hinweisleiste ---------------------------------------------------
     Schliessbar, und geschlossen bleibt sie fuer die Sitzung. Bewusst
     sessionStorage und nicht localStorage: beim naechsten Besuch darf der
     Hinweis wieder da sein, innerhalb eines Besuchs nicht.

     Schmal wechseln die drei Zeilen einzeln durch, je fuenf Sekunden. Bei
     reduzierter Bewegung steht die erste Zeile still. */
  (function () {
    var leiste = document.getElementById('hinweisleiste');
    if (!leiste) return;
    var speicher = null;
    try { speicher = window.sessionStorage; } catch (e) { speicher = null; }

    if (speicher && speicher.getItem('hinweis-zu') === '1') {
      leiste.hidden = true;
      document.documentElement.style.setProperty('--leiste-h', '0px');
      return;
    }

    /* Der Hero ist so hoch wie das Fenster MINUS dieser Leiste
       (css/tokens.css, --buehne-h). Ohne das schob die Leiste Zaehler und
       Knoepfe unter den Rand - gemessen bei 1366, 1440 und 1920 px genau um
       die Leistenhoehe. Geschlossen steht dort 0 und der Hero waechst
       wieder auf die volle Hoehe. */
    function hoeheMelden() {
      var h = leiste.hidden ? 0 : Math.round(leiste.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--leiste-h', h + 'px');
    }
    hoeheMelden();
    window.addEventListener('resize', hoeheMelden);
    if (window.ResizeObserver) new ResizeObserver(hoeheMelden).observe(leiste);

    var zu = leiste.querySelector('[data-hinweis-zu]');
    if (zu) {
      zu.addEventListener('click', function () {
        leiste.hidden = true;
        hoeheMelden();
        if (window.FLAVRBLOOM && window.FLAVRBLOOM.lenis) window.FLAVRBLOOM.lenis.resize();
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
        try { if (speicher) speicher.setItem('hinweis-zu', '1'); } catch (e) {}
      });
    }

    var punkte = leiste.querySelectorAll('[data-hinweise] li');
    if (punkte.length < 2) return;
    var schmal = window.matchMedia('(max-width: 47.9375rem)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var i = 0, takt = null;

    function zeigen(n) {
      for (var k = 0; k < punkte.length; k++) {
        if (k === n) punkte[k].setAttribute('data-an', '');
        else punkte[k].removeAttribute('data-an');
      }
    }

    function starten() {
      zeigen(0);
      i = 0;
      if (takt) window.clearInterval(takt);
      if (reduce.matches) return;      /* eine Zeile, die stehen bleibt */
      takt = window.setInterval(function () {
        i = (i + 1) % punkte.length;
        zeigen(i);
      }, 5000);
    }

    function pruefen() {
      if (schmal.matches) starten();
      else {
        if (takt) { window.clearInterval(takt); takt = null; }
        /* Breit stehen alle drei nebeneinander - data-an stoert dort nicht,
           aber es soll auch nichts fehlen. */
        for (var k = 0; k < punkte.length; k++) punkte[k].setAttribute('data-an', '');
      }
    }

    pruefen();
    (schmal.addEventListener ? schmal.addEventListener.bind(schmal, 'change')
                             : schmal.addListener.bind(schmal))(pruefen);
  })();

  var knopf = document.querySelector('.menueknopf');
  var menue = document.getElementById('hauptmenue');
  if (!knopf || !menue) return;

  function auf(tastatur) {
    menue.hidden = false;
    /* 31.10.2026: Mit der Tastatur geoeffnet, springt der Fokus auf den ersten Eintrag; das Menue steht im Code vor dem Knopf. */
    if (tastatur) requestAnimationFrame(function () { var erst = menue.querySelector('a[href], summary, button'); if (erst) erst.focus(); });
    menue.setAttribute('data-zu', '');
    /* Ein Bild abwarten, sonst faengt der Uebergang beim Endzustand an. */
    requestAnimationFrame(function () { menue.removeAttribute('data-zu'); });
    knopf.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', taste);
    document.addEventListener('pointerdown', daneben, true);
  }

  function zu(fokus) {
    menue.setAttribute('data-zu', '');
    knopf.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', taste);
    document.removeEventListener('pointerdown', daneben, true);
    window.setTimeout(function () {
      if (knopf.getAttribute('aria-expanded') === 'false') menue.hidden = true;
    }, 240);
    if (fokus) knopf.focus();
  }

  function taste(e) {
    if (e.key === 'Escape') { zu(true); }
  }

  function daneben(e) {
    if (!menue.contains(e.target) && !knopf.contains(e.target)) zu(false);
  }

  knopf.addEventListener('click', function (e) {
    if (knopf.getAttribute('aria-expanded') === 'true') zu(true);
    else auf(e.detail === 0);
  });

  /* Wird das Fenster breit, uebernimmt die Pille - das Menue muss dann zu
     sein, sonst bleibt es als Kasten stehen. */
  var breit = window.matchMedia('(min-width: 64rem)'); /* 10.10.2026: Pille erst ab 1024 px, siehe fb-kopf-fest.css */
  (breit.addEventListener ? breit.addEventListener.bind(breit, 'change')
                          : breit.addListener.bind(breit))(function (e) {
    if (e.matches && knopf.getAttribute('aria-expanded') === 'true') zu(false);
  });

  /* --- Angepinnte Kopfzeile (10.10.2026) --------------------------------
     Die Kopfzeile steht fest oben (assets/fb-kopf-fest.css). Solange die
     Hinweisleiste noch zu sehen ist, sitzt sie direkt darunter und rutscht
     mit ihr nach oben (--kopf-top). Sobald gescrollt wird, bekommt sie eine
     Papierflaeche (.ist-fest), damit sie auf jeder Section lesbar bleibt.
     Auf der Startseite wechselt die Buehne beim Scrollen die Sorte; die
     Kopfzeile uebernimmt sie, damit ihre Schrift oben im Hero passt. */
  (function () {
    var bereich = document.querySelector('[data-kopf]');
    var kopf = bereich && bereich.querySelector('.header');
    if (!kopf) return;
    var leiste = document.getElementById('hinweisleiste');
    var wartet = false;

    function leisteHoehe() {
      return leiste && !leiste.hidden ? leiste.offsetHeight : 0;
    }
    var hoehe = leisteHoehe();

    /* Wo endet die farbige Buehne? Startseite: das Hero klebt, also zaehlt,
       wann das Statement oben ankommt. Produktseite: die Buehne scrollt mit. */
    var buehnenEnde = document.querySelector('section.statement');
    var produktBuehne = !buehnenEnde && document.querySelector('.pbuehne, .sbuehne');
    var aufBuehne = bereich.classList.contains('kopfbereich--ueber');

    /* 29.10.2026 (Kevin: „jede Seite smooth scrollen“): --kopf-top stand an <html>. Jede Aenderung liess den Browser die
       Stile der ganzen Seite neu rechnen, und das Lesen von offsetHeight direkt danach erzwang das sofort; im Profiler
       70 ms beim ersten Scrollen der Startseite. Jetzt steht der Wert nur an den Elementen, die ihn brauchen, er wird
       nur bei einer Aenderung geschrieben, und gelesen wird vor dem Schreiben. */
    var abstandsZiele = [bereich].concat(Array.prototype.slice.call(document.querySelectorAll('.standort, .pszene')));
    var letzterAbstand = null;

    function stellen() {
      wartet = false;
      var y = Math.max(0, window.scrollY);
      var kh = kopf.offsetHeight;
      var buehneWeg = false;
      if (buehnenEnde) buehneWeg = buehnenEnde.getBoundingClientRect().top <= kh;
      else if (produktBuehne) buehneWeg = produktBuehne.getBoundingClientRect().bottom <= kh;
      var abstand = Math.max(0, hoehe - y) + 'px';
      if (abstand !== letzterAbstand) {
        letzterAbstand = abstand;
        for (var z = 0; z < abstandsZiele.length; z++) abstandsZiele[z].style.setProperty('--kopf-top', abstand);
      }
      /* 10.10.2026 (Kevin): Ueber der farbigen Buehne bleibt die Kopfzeile
         durchsichtig. Ist die Buehne aus dem Bild, traegt sie die Farbe der
         gewaehlten Sorte (.ist-sorte); Seiten ohne Buehne bekommen Papier. */
      kopf.classList.toggle('ist-sorte', aufBuehne && buehneWeg);
      kopf.classList.toggle('ist-fest', !aufBuehne && y > 8);
      kopf.classList.toggle('ist-oben', aufBuehne && !buehneWeg && y > 8);
    }
    function anstossen() {
      if (!wartet) { wartet = true; window.requestAnimationFrame(stellen); }
    }
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', function () { hoehe = leisteHoehe(); anstossen(); });
    if (leiste) {
      new MutationObserver(function () { hoehe = leisteHoehe(); anstossen(); })
        .observe(leiste, { attributes: true, attributeFilter: ['hidden'] });
    }
    stellen();

    var buehne = document.querySelector('.stage[data-flavor]');
    if (buehne && bereich.classList.contains('kopfbereich--ueber')) {
      var spiegeln = function () { bereich.setAttribute('data-flavor', buehne.getAttribute('data-flavor')); };
      spiegeln();
      new MutationObserver(spiegeln).observe(buehne, { attributes: true, attributeFilter: ['data-flavor'] });
    }
  })();
})();
